import script from "./UPopupMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UPopupMessage.vue?vue&type=script&lang=ts&setup=true"

import "./UPopupMessage.vue?vue&type=style&index=0&id=c9799f28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9799f28"]])

export default __exports__